<template>
	<div>
		<div class="flex flex-c pagination">
			<el-pagination @current-change='currentChange' background layout="prev, pager, next" :total="total" :page-size='page_size'>
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			total: {
				type: Number,
				default: 1000
			},
			page_size: {
				type: Number,
				default: 10
			}
		},
		data() {
			return {

			}
		},
		methods:{
			currentChange(e){
				this.$emit('currentChange',e)
			},
		}
	}
</script>

<style lang="less" scoped>
	.pagination {
		margin-top: 33px;
	}

	/deep/ .el-pagination {
		display: flex;
		align-items: center;
	}

	/deep/ .number {
		width: 31px !important;
		height: 31px !important;
		border-radius: 2px 2px 2px 2px !important;
		font-family: HONOR Sans CN, HONOR Sans CN !important;
		font-weight: 400 !important;
		font-size: 16px !important;
		color: #4E5969 !important;
		background-color: transparent !important;
		margin: 0 9px !important;
		padding: 0 !important;
		line-height: 31px !important;
	}

	/deep/ .more {
		background-color: transparent !important;
		color: #4E5969 !important;
		width: 31px !important;
		height: 31px !important;
	}

	/deep/ .btn-next {
		background-color: transparent !important;
		width: 31px !important;
		height: 31px !important;
	}

	/deep/ .btn-prev {
		background-color: transparent !important;
		width: 31px !important;
		height: 31px !important;
	}

	/deep/ .active {
		width: 31px !important;
		height: 31px !important;
		background: #00A73C !important;
		border-radius: 2px 2px 2px 2px !important;
		color: #fff !important;
	}
</style>